import { render, staticRenderFns } from "./tag-filter.vue?vue&type=template&id=3e0c2a35&scoped=true&"
import script from "./tag-filter.vue?vue&type=script&lang=js&"
export * from "./tag-filter.vue?vue&type=script&lang=js&"
import style0 from "./tag-filter.vue?vue&type=style&index=0&id=3e0c2a35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c2a35",
  null
  
)

export default component.exports